import { useState, useCallback } from 'react';
import { useFluxStore } from '@evertrue/et-flux';
import { Checkbox, Modal2 } from '@evertrue/et-components';
import SelectedContactsSource from 'apps/contact/sources/selected-contacts-source';
import SelectedContactsStore from 'apps/contact/stores/selected-contacts-store';
import SelectedErrorModal from 'apps/contact/components/contacts/selected-error-modal';
import PropTypes from 'prop-types';

const selectedContactsStoreMap = (id) => ({
  isChecked: SelectedContactsStore.isSelected(id),
  isAll: SelectedContactsStore.getIsAllSelected(),
});

const SelectContactCheckbox = ({ id, name, trip_id, onContactSelectChange = () => {} }) => {
  const [showModal, setShowModal] = useState(false);

  const { isChecked, isAll } = useFluxStore(SelectedContactsStore, () => selectedContactsStoreMap(id));

  const handleChange = useCallback(() => {
    if (isChecked) {
      SelectedContactsSource.unselect(id);
      if (isAll) {
        SelectedContactsSource.selectAll(false);
        SelectedContactsSource.toggleSelectedIndicator(false);
      }
    } else if (SelectedContactsStore.getSelectedContacts().length < 50) {
      SelectedContactsSource.select(id);
    } else {
      setShowModal(true);
    }

    onContactSelectChange();
  }, [id, isChecked, isAll, onContactSelectChange]);

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
  }, []);

  return (
    <>
      <Checkbox value={String(id)} checked={isAll ? true : isChecked} onChange={handleChange} label={name} />

      <Modal2 isOpen={showModal} onClose={handleCloseModal}>
        <SelectedErrorModal tripId={trip_id} remove={handleCloseModal} />
      </Modal2>
    </>
  );
};

export default SelectContactCheckbox;

SelectContactCheckbox.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string.isRequired,
  trip_id: PropTypes.string,
  onContactSelectChange: PropTypes.func,
};
